/**
 * Класс для работы с HTTP Заголовками.
 *
 * Внутри заголовки хранятся в виде массива, так как в браузере
 * используется XMLHttpRequest и нет возможности разом установить
 * все заголовки.
 *
 * @export
 * @class Headers
 * @implements {IHeaders}
 */
export class Headers {
    headers;
    constructor(headers) {
        if (Array.isArray(headers)) {
            this.headers = headersToLowerCase(headers);
        }
        else {
            this.headers = headersToLowerCase(Object.entries(headers));
        }
    }
    get(header) {
        const lowerHeaderName = header.toLowerCase();
        const result = this.headers.find(([name]) => name === lowerHeaderName);
        return result?.length && result[1];
    }
    set(header, value) {
        const lowerHeaderName = header.toLowerCase();
        const index = this.headers.findIndex(([name]) => name === lowerHeaderName);
        if (index !== -1) {
            this.headers[index] = [lowerHeaderName, value];
        }
        else {
            this.headers.push([lowerHeaderName, value]);
        }
    }
    toArray() {
        return this.headers;
    }
    toMap() {
        return Object.fromEntries(this.headers);
    }
    inject(rawHeaders) {
        const headers = Array.isArray(rawHeaders)
            ? headersToLowerCase(rawHeaders)
            : headersToLowerCase(Object.entries(rawHeaders));
        this.headers = this.headers.filter(([name]) => !headers.some(([iHeader]) => iHeader === name)).concat(headers);
    }
}
function headersToLowerCase(headers) {
    return headers.map(([key, value]) => [key.toLowerCase(), value]);
}
//# sourceMappingURL=Headers.js.map